// extracted by mini-css-extract-plugin
export default {"Environments":"Environments_Environments__xRe4P","ActionButton":"Environments_ActionButton__6fuqs","TabContents":"Environments_TabContents__YkYBC"};